const neg = (x) => -x;
export default neg;
